module.exports = __webpack_public_path__ + "static/media/highcroft.d51cfced.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/highcroft.jpg
// module id = 303
// module chunks = 0